import {
	chain,
	zipObject
} from 'lodash';

import Http from '@/support/http';
import S from '@/support/string';

export default {
	state: {
		list: [],
		selected: {}
	},
	getters: {
		classGrade: (state) => state.selected,
		classGradeList: (state) => state.list
	},
	mutations: {
		SET_CLASS_GRADE_LIST(state, payload) {
			state.list = payload;
		},
		SET_SELECTED_CLASS_GRADE(state, payload) {
			state.selected = payload;
		}
	},
	actions: {
		setSelectedClassGrade(context, payload) {
			context.commit('SET_SELECTED_CLASS_GRADE', payload);
		},
		getClassGrade(context, payload) {

			if (payload) {

				const queryString = S.makeQueryString(payload.filter);
				const route = `v1/school-class-grade/user/${ payload.userId }${ queryString }`;

				return Http.get(route).then((response) => {

					// Based at http://jsfiddle.net/thefourtheye/WYCF8/
					const data = chain(response.data).groupBy('level').toPairs().map((current) => {

						let zip = zipObject([
							'gradeLevel',
							'list'
						], current);

						zip.gradeName = this.getters.ENUM['SchoolClassLevelType'][zip.gradeLevel];

						return zip;

					}).value();

					context.commit('SET_CLASS_GRADE_LIST', data);

					return response;

				});

			}

		}

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-grade/store.js